<template>
  <div :class="{ noLabels: hideLabels }" class="cwSlider">
    <h3 class="label__header" v-if="labelHeader">{{ labelHeader }}</h3>
    <span class="value">{{ labelMin ? $t(labelMin) : $n(slider.min) + suffix }}</span>
    <div class="content">
      <vue-slider @change="onValueChange" v-bind="slider" v-model="slider.value">
        <template v-slot:tooltip>
          <div class="arrow_box">{{ $n(slider.value) }}{{ suffix }}</div>
        </template>
      </vue-slider>
    </div>
    <!-- <pre>{{slider}}</pre> -->
    <span class="value">{{ labelMax ? $t(labelMax) : $n(slider.max) + suffix }}</span>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';

export default {
  name: 'CwSlider',
  components: { VueSlider },
  data() {
    return {
      slider: {
        value: this.currentValue,
        height: 6,
        min: this.minValue,
        max: this.maxValue,
        interval: this.distance ? this.distance : 1,
        dotSize: 24,
        marks:
          (this.maxValue - this.minValue) / this.distance >= 20
            ? [this.minValue, this.maxValue]
            : true,
        hideLabel: true,
        stepStyle: {
          backgroundColor: '#becdd7',
          visibility: this.showDots ? 'visible' : 'hidden',
          width: '12px',
          height: '12px',
          borderRadius: '12px',
          marginTop: '-3px'
        },
        railStyle: {
          backgroundColor: '#becdd7'
        },
        dotStyle: {
          width: '24px',
          height: '24px',
          borderRadius: '12px',
          backgroundColor: '#41aaaa',
          boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1)',
          border: 'solid 2px #ffffff',
          boxSizing: 'border-box'
        },
        dotOptions: [
          {
            tooltip: 'always'
          }
        ],
        contained: 'true'
      }
    };
  },
  props: {
    currentValue: {
      required: true
    },
    distance: {
      type: Number,
      required: false
    },
    minValue: {
      type: Number,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    },
    suffix: {
      default: '',
      type: String,
      required: false
    },
    hideLabels: {
      default: false,
      type: Boolean,
      required: false
    },
    showDots: {
      default: true,
      type: Boolean,
      required: false
    },
    labelMin: {
      default: '',
      type: String,
      required: false
    },
    labelMax: {
      default: '',
      type: String,
      required: false
    },
    labelHeader: {
      default: '',
      type: String,
      required: false
    }
  },
  methods: {
    onValueChange(val) {
      this.$emit('valueChanged', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.cwSlider {
  width: 100%;
  position: relative;
  padding-top: 38px;
  padding-bottom: 24px;
  cursor: pointer;
  z-index: 0;

  .value {
    float: left;
    width: 12%;
    font-size: 11px;
    color: $petrol;
    text-align: center;
    margin-top: 9px;
    margin-left: 10px;
  }

  .arrow_box {
    font-size: 14px;
    text-align: center;
    color: $charcoal-grey;
    padding: 6px 15px;
    position: relative;
    background: $white;
    border: 1px solid $cloudy-blue;
    border-radius: 6px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    margin-left: 2px;
  }
  .arrow_box:after,
  .arrow_box:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: $white;
    border-width: 6px;
    margin-left: -6px;
  }
  .arrow_box:before {
    border-color: rgba(190, 205, 215, 0);
    border-top-color: $cloudy-blue;
    border-width: 7px;
    margin-left: -7px;
  }

  .content {
    float: left;
    width: 67%;
  }

  .noLabels {
    .value {
      display: none;
    }

    .content {
      width: 100%;
    }
  }

  .label__header {
    font-family: 'Open Sans', sans-serif;
    font-size: 0.8125rem;
    color: #ffffff;
    color: #41aaaa;
    margin: 0 0 10px 20px;
    padding-bottom: 58px;
  }
}

.withBorder {
  .cwSlider {
    padding-top: 8px;
    height: 80px;

    .label__header {
      color: #879baa;
      padding-bottom: 38px;
    }
  }
}
</style>
